import script from "./BaseTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&setup=true&lang=js"

import "./BaseTooltip.vue?vue&type=style&index=0&id=6c4f007d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c4f007d"]])

export default __exports__